<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/rotation/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      addShowPower="/rotation/add"
    >
      <el-form-item label="类型">
        <el-select v-model="formModel.type">
          <el-option
            v-for="item in Type"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="name"
        label="名称"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="type"
        label="类型"
        min-width="100"
        :formatter="formatterTableGoodsType"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="name"
        label="状态"
        min-width="100"
        :formatter="typeStatus"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="image" label="图片1" min-width="100">
        <template slot-scope="scope">
          <div
            class="iconUrl"
            :style="
              'background:url(' + scope.row.image + ') center/cover no-repeat'
            "
          ></div>
        </template>
      </el-table-column>
      <el-table-column prop="image2" label="图片2" min-width="100">
        <template slot-scope="scope">
          <div
            class="iconUrl"
            :style="
              'background:url(' + scope.row.image2 + ') center/cover no-repeat'
            "
          ></div>
        </template>
      </el-table-column>
      <el-table-column
        prop="sort"
        label="排序"
        min-width="190"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="190"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        min-width="190"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="realName"
        label="操作人"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column label="操作" min-width="160">
        <template slot-scope="scope">
          <el-button type="text" @click="openAddDialog(scope.row)"
            >修改
          </el-button>
          <el-button type="text" @click="handleDelete(scope.row)"
            >删除
          </el-button>
          <el-button type="text" @click="handleStatus(scope.row)"
            >{{ scope.row.status == 0 ? "启用" : "禁用" }}
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      labelWidth="120px"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
    >
      <el-form-item label="名称" prop="name">
        <el-input
          type="text"
          v-model="dialogModel.name"
          placeholder="请输入名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-select v-model="dialogModel.type" clearable>
          <el-option
            v-for="item in Type.slice(1, Type.length)"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="图片1" prop="image">
        <el-upload
          class="avatar-uploader"
          :action="uploadUrl + '8883/picture/upload'"
          :data="commonParams"
          name="picture"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img
            v-if="dialogModel.image"
            :src="dialogModel.image"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="图片2" prop="image2">
        <el-upload
          class="avatar-uploader"
          :action="uploadUrl + '8883/picture/upload'"
          :data="CommonParams"
          name="picture"
          :show-file-list="false"
          :on-success="HandleAvatarSuccess"
          :before-upload="BeforeAvatarUpload"
        >
          <img
            v-if="dialogModel.image2"
            :src="dialogModel.image2"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <i
        class="el-icon-warning"
        style="
          color: #e6a23c;
          margin-left: 64px;
          position: relative;
          top: -25px;
        "
        >轮播图宽高为660*206!</i
      >
      <el-form-item label="" style="margin-left: 65px">
        <el-checkbox v-model="dialogModel.enableCard" label=""
          >信用卡</el-checkbox
        >
        <el-checkbox v-model="dialogModel.enableAlipay" label=""
          >支付宝</el-checkbox
        >
      </el-form-item>
      <el-form-item label="金额" prop="money">
        <el-input
          type="text"
          maxlength="5"
          v-model.number="dialogModel.money"
          placeholder="请输入金额"
        ></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input
          type="text"
          maxlength="5"
          v-model.number="dialogModel.sort"
          placeholder="请输入排序"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          type="textarea"
          :rows="5"
          placeholder="请输入内容"
          v-model="dialogModel.remark"
        >
        </el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
// 组件
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import SelectOrgans from "components/business/SelectOrgans";

// 接口
import APPService from "service/APPService";
import MemberLevelService from "service/MemberLevelService";
// 时间
import TimeRange from "service/constant/TimeRange";
// 类别和状态
import EnableStatus from "service/constant/EnableStatus";
import privateKey from "service/constant/privateKey";
import Server from "common/conf/Server";
// 混合js
import {
  encrypt,
  urlEncode,
  objKeySort,
  debounce,
} from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
// 语法糖
import { mapGetters } from "vuex";

export default {
  name: "rotation",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    SelectOrgans,
  },
  data() {
    return {
      Type: [],
      banner: "",
      uploadUrl: Server[process.env.NODE_ENV], //图片
      UploadUrl: Server[process.env.NODE_ENV], //图片
      formModel: {
        type: "",
      },
      tableData: [],
      submitService: APPService.rbannerList,
      page: {},
      isPage: false,
      itemId: "",
      // couponTypes: [],
      dialogModel: {
        name: "",
        type: "",
        image: "",
        image2: "",
        enableCard: false,
        enableAlipay: false,
        money: "",
        sort: "",
        remark: "",
      },
      dialogRules: {
        name: [
          {
            required: true,
            message: "请输入名称",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择类型",
          },
        ],
        image: [
          {
            required: true,
            message: "请上传图片",
          },
        ],
      },
      isFlag: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.banner = this.$route.params.item;
    this.load();
    this.getTypeNames("paymanage", (res) => {
      this.Type = [
        {
          dictKey: "",
          dictValue: "全部",
        },
        ...res,
      ];
    });
  },
  computed: {
    submitData() {
      // if (this.formModel.time == null || this.formModel.time == "") {
      //   this.formModel.time = [];
      // }
      this.params = {
        pId: this.banner,
        type: this.formModel.type,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      // if (this.formModel.time.length) {
      //   // 0代表开始时间
      //   this.params.createTimeStart = this.formModel.time[0];
      //   // 1代表结束时间
      //   this.params.createTimeEnd = this.formModel.time[1];
      // }
      return this.params;
    },
    dialogData() {
      const params = {
        pId: this.banner,
        type: this.dialogModel.type,
        name: this.dialogModel.name,
        image: this.dialogModel.image,
        image2: this.dialogModel.image2,
        enableCard: this.dialogModel.enableCard == true ? "1" : "0",
        enableAlipay: this.dialogModel.enableAlipay == true ? "2" : "0",
        money: this.dialogModel.money,
        sort: this.dialogModel.sort,
        remark: this.dialogModel.remark,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      return this.itemId ? APPService.rbannerEdit : APPService.rbannerInsert;
    },
    // commonParams() {
    //   const params = {
    //     serverType: 1,
    //     tatId: privateKey[process.env.BRANCH_ENV].tatId,
    //     reqTime: new Date().format("yyyy-MM-dd HH:mm:ss"),
    //   };
    //   params.sign = encrypt(
    //     urlEncode(objKeySort(params)) +
    //       "&priKey=" +
    //       privateKey[process.env.BRANCH_ENV].priKey
    //   );
    //   return params;
    // },
    commonParams() {
      const params = {
        serverType: this.serverType,
        tatId: this.tatId,
        reqTime: new Date().format("yyyy-MM-dd HH:mm:ss"),
      };
      params.sign = encrypt(
        urlEncode(objKeySort(params)) + "&priKey=" + privateKey.priKey
      );
      return params;
    },
    CommonParams() {
      const params = {
        serverType: this.serverType,
        tatId: this.tatId,
        reqTime: new Date().format("yyyy-MM-dd HH:mm:ss"),
      };
      params.sign = encrypt(
        urlEncode(objKeySort(params)) + "&priKey=" + privateKey.priKey
      );
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  methods: {
    load() {
      this.formModel = {
        type: "",
      };

      this.page = this.$refs.commonTable.page;
      // this.getCouponTypes();
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },

    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    formatterTableGoodsType(row, column, cellValue, index) {
      let value = "";
      this.Type.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });

      return value ? value : "--";
    },
    typeStatus: function (row, column) {
      switch (row.status) {
        case 0:
          return "禁用";
          break;
        case 1:
          return "启用";
          break;
        default:
          return "--";
      }
    },
    handleDelete(item) {
      this.showConfirm("确定删除该类别？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        APPService.rbannerDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    handleStatus(item) {
      this.showConfirm(`确定${item.status == 0 ? "启用" : "禁用"}？`)
        .then(() => {
          this.doStatus(item);
        })
        .catch(() => {});
    },
    doStatus(item) {
      this.doLoad(
        APPService.rbannerStatus,
        {
          id: item.id,
          status: item.status == "1" ? "0" : "1",
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    openAddDialog(item) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
        this.dialogModel.enableCard = this.dialogModel.enableCard == "1";
        this.dialogModel.enableAlipay = this.dialogModel.enableAlipay == "2";
      }
      this.$refs.formDialog.open();
      this.$nextTick(() => {
        this.$refs.formDialog.clearValidate();
      });
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    // 弹框关闭清空数据
    dialogClose() {
      this.dialogModel = {
        name: "",
        type: "",
        image: "",
        image2: "",
        enableCard: false,
        enableAlipay: false,
        money: "",
        sort: "",
        remark: "",
      };
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    handleAvatarSuccess(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.image = res.contents;
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    HandleAvatarSuccess(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.image2 = res.contents;
      });
    },
    BeforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
  },
};
</script>

<style scoped>
.button {
  width: 50px;
  padding: 11px 10px;
  margin-left: 49px;
  display: block;
  float: left;
}

.text {
  width: 145px !important;
  margin-left: 12px;
  float: left;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/Rotation.vue